// Brief 85 §2 — OpponentContactModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN. The body below is byte-identical to the `case "oc":`
// clause it left —
//   sha256 642d66ea7001c6997e67dfea4f41798b383d23e4928d699f9d2e61a72017412e
// — including its original indentation, which is why it sits deeper than this
// file's own wrapper. Only the imports, the Props type, the signature and the
// `return (` / `);` are new.
// Do not reformat: the indentation IS the proof.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";
import type { TFn } from "../../lib/taxonomyTypes";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { id?: string | null };

type Props = {
  F: Vocab["F"];
  NA: Vocab["NA"];
  TitSel: Vocab["TitSel"];
  _mt: Vocab["_mt"];
  cm: () => void;
  form: ModalForm;
  opponentContacts: readonly unknown[];
  saveEntity: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown) => void;
  setOpponentContacts: (v: readonly unknown[]) => void;
  t: TFn;
};

export default function OpponentContactModal({
  F,
  NA,
  TitSel,
  _mt,
  cm,
  form,
  opponentContacts,
  saveEntity,
  setOpponentContacts,
  t,
}: Props) {
  return (
          <ModalLayout
            recordId={form.id} // 204 §G — the person's internal id in the header
            title={form.id ? _mt("Edit Opp. Contact") : _mt("New Opp. Contact")}
            onClose={cm}
            onSave={() => saveEntity(SK.oc, opponentContacts, setOpponentContacts, form)}
          >
              <>
                <div className="field-row">
                  {TitSel}
                  {F("First Name *", "firstName", "", 1)}
                </div>
                <div className="field-row">
                  {F("Last Name *", "lastName")}
                  {F("Function / Role", "function")}
                </div>
                {NA({
                  pool: opponentContacts,
                  typeLabel: t("type.opponent_contact", {
                    fallback: "opponent contact",
                  }),
                })}
                <div className="field-row">
                  {F("Email", "email")}
                  {F("Phone", "phone")}
                </div>
                {F("Company", "company")}
              </>
          </ModalLayout>
  );
}
